import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
  name: 'cutStarted'
})
export class CutStartedPipe implements PipeTransform {

  constructor(
    private _datePipe:DatePipe
  ) {}

  transform(value: any): any {
    if(value.cut && value.cut.times && value.cut.times.length > 0) {
      const last = value.cut.times[value.cut.times.length -1];
      const t = (last.timeType == 'Start') ? 'Started' : 'Stopped';
      return t + ' ' + this._datePipe.transform(last.date, 'short');
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/inventory/pipes/cut-started-pipe.ts